export const bootstrapStatus = {
  promise: null,
  completed: false,
  error: null,
};

export const resetAuthBootstrapState = () => {
  bootstrapStatus.promise = null;
  bootstrapStatus.completed = false;
  bootstrapStatus.error = null;
};
